import { Component } from '@angular/core';
import { IComponentDetails } from '../lib/interfaces/component-details.interface';
import { StepComponent } from '../lib/modules/credit-application/components/stepcomponent.class';
import { ComponentGroup } from '../lib/enum/component-group.enum';

@Component({
  selector: 'dt-test',
  template: '<p>Test</p>',
  standalone: false
})
export class TestComponent {
  constructor() { }
}

export const mockNextComponentInput: IComponentDetails = {
  component: new StepComponent(TestComponent, 'TestComponent', ComponentGroup.PersonalInfo, true),
  componentName: 'TestComponent',
  groupName: 'TestGroup'
};
